module.exports = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>\n    Artboard\n  </title>\n  <path d=\"M13 8c0-2.757-2.243-5-5-5S3 5.243 3 8s2.243 5 5 5 5-2.243 5-5zm3.586 10l-4.399-4.399A6.961 6.961 0 0 1 8 15a7 7 0 1 1 7-7 6.961 6.961 0 0 1-1.399 4.187L18 16.586 16.586 18z\" fill=\"#FFF\" fill-rule=\"evenodd\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./assets/svg/icon-18-search.svg
// module id = 3705
// module chunks = 168707334958949